import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const PopulationTrendChart = ({ data, title }) => {
  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation">
      <h3 className="text-xl font-semibold text-foreground mb-6">{title}</h3>
      <div className="w-full h-80" aria-label={`${title} Line Chart`}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 255, 255, 0.1)" />
            <XAxis 
              dataKey="year" 
              stroke="#b0bec5"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="#b0bec5"
              style={{ fontSize: '12px' }}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: '#1f3a39', 
                border: '1px solid #02453e',
                borderRadius: '8px',
                color: '#ffffff'
              }}
            />
            <Legend 
              wrapperStyle={{ color: '#b0bec5' }}
            />
            <Line 
              type="monotone" 
              dataKey="population" 
              stroke="#1b8a5b" 
              strokeWidth={3}
              dot={{ fill: '#1b8a5b', r: 4 }}
              activeDot={{ r: 6 }}
              name="Population Count"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PopulationTrendChart;